import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

export const PickerRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
  width: 100%;
`;

export const FieldLabel = styled.label`
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/** Schedule-every row: NumberStepper (fixed) + Unit dropdown (flex). */
export const EveryRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  width: 100%;
`;

export const StepperSlot = styled.div`
  width: 104px;
  flex-shrink: 0;
`;

export const UnitSlot = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;

/** Equal-width two-column slot: hour + timezone. */
export const TwoCol = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing[3]};
  width: 100%;

  > * {
    flex: 1 1 0;
    min-width: 0;
  }
`;

/** Repeat-on row: 7 day pills, space-between. */
export const DayRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const HelperText = styled.p<{ $error?: boolean }>`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${({ theme, $error }) =>
    $error ? rawColors.accent.red500 : theme.colors.text.secondary};
`;
